export default {"src":"/_next/static/media/timeline-arrow-right-painted.822deced.svg","height":10,"width":14};